<div class="page-wrapper" *ngIf="hasPrivilege$ | async; else noPrivilege">
  <h1>M30 letöltés</h1>
  
  <app-m30-grid [forAdmin]="true" [allM30$]="allM30$">
  </app-m30-grid>
</div>

<ng-template #noPrivilege>
  <div class="no-privilege">
    <h2>Nincs jogosultságod az oldal megtekintéséhez.</h2>
  </div>